export const config = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || '',
  supabaseKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || '',
  osrmBaseUrl: (import.meta.env.VITE_OSRM_BASE_URL || 'https://router.project-osrm.org').replace(/\/$/, ''),
  mapStyleUrl: import.meta.env.VITE_MAP_STYLE_URL || '',
};
export const isSupabaseConfigured = Boolean(config.supabaseUrl && config.supabaseKey && !config.supabaseUrl.includes('TWOJ-PROJEKT'));
